export default __webpack_public_path__ + "static/media/light.83ca4876.png";